

let _ = require('../_.js');
let $ = jQuery;

let _finalize_choice_round_actions_hooked = false;
let _finalize_choice_round_modal_sub = false;
let _finalize_choice_round_modal_countdown_interval = false;


// Code in auctionui-bids and auctionui-tracks is closely related and not well organized.
// A refactor is required.

_.AuctionUI_Bids = class AuctionUI_Bids {

    static _old_track_id = null

    static session_updated_handler() {
        _.AuctionUI_Bids._update_bidding_ui();
    }

    static async init() {

        console.log('Started AuctionCast Bidding Module');

        // Set details on right sidebar
        _.AuctionUI.on_update_auction_items(_.AuctionUI_Bids._update_bidding_ui);

        // Click quickbid button.  This should be moved somewhere else.
        _.on_ui_update_once(".ac-btn-quickbid", function () {
            $(this).click(_.AuctionUI_Bids._do_quickbid);
        });

        _.on_ui_update_once(".ac-btn-custombid", function () {
            $(this).click(_.AuctionUI_Bids.do_custom_bid);
        });

        _.on_ui_update_once(".ac-btn-withdrawbid", function () {
            $(this).click(async function (e) {
                await $(".ac-menu-bid-dropdown").aFadeOut();
                let current_round = await _.AuctionUI.get_current_round();
                if (await _.Lib_Auction_Bids.can_bid(current_round)) {
                    _.AuctionUI_Bids.try_withdraw_bid();
                }
            });
        });

        _.on_ui_update_once(".btn-view-bid-history", function () {
            $(this).click(async function (e) {
                _.AuctionUI_BidHistory.show((await _.AuctionUI.get_current_round()).id);
            });
        });

        _.on_ui_update_once(".ac-btn-action-lot-details", function () {
            $(this).click(async function (e) {
                _.AuctionUI_Router.navigate_to("lots/" + ((await _.AuctionUI.get_current_item()).id));
            });
        });

        // The small thumbnail on the left side of the bidding dialog
        _.on_ui_update_once(".ac-component-bid .item-photo", function () {
            $(this).click(async function (e) {
                // Navigate to lot details if multi track auction
                let auction = _.ac_state.auction;
                let auction_items = await auction.auction_items.fetch();
                if (auction_items.length > 1) {
                    _.AuctionUI_Router.navigate_to("lots/" + ((await _.AuctionUI.get_current_item()).id));
                }
            });
        });

        // Formatter for custom bid input
        _.on_ui_update_once(".custom-bid-input-amount", function () {
            $(this).currencyInput(false);
        });
    }

    // TODO: Break this function into smaller functions.
    static async _do_quickbid() {

        let current_round = await (await _.AuctionUI.get_current_round()).private();

        if (await _.Lib_Auction_Bids.can_bid(current_round)) {
            let best_bid_by_user = await _.Lib_Auction_Bids.best_bid_by_user(current_round);
            let is_auto_bid = best_bid_by_user && best_bid_by_user.status == App_Models_Bid.STATUS_MAX_BID_ACTIVE;
            if (is_auto_bid) {
                _.AuctionUI_Bids.edit_bid_modal();
            } else if (!(await _.Lib_Auction_Bids.user_bid_pending(current_round))) {
                _.AuctionUI_Bids.try_bid(null, $(".ac-btn-quickbid").data('amount') * 1);
            } else {
                _.AuctionUI_Bids.edit_bid_modal();
            }
        } else if (!_.Lib_Auction_Bids.auction_accepting_bids(current_round)) {
            _.Modal.alert("Not Accepting Bids", "Bids are not currently being accepted" + (!_.AuctionUI.auction_is_choice() ? " for this item" : "") + ".");
        } else if (! await _.AuctionUI_Session.get_registrant()) {
            _.AuctionUI_Bids.create_account_or_login_form();
        } else if (!_.Lib_Auction_Bids.user_registration_approved()) {
            if (!_.ac_state.registration) {
                _.ac_registeration_modal();
            }
            else if (!_.ac_state.registration.approved) {
                _.Modal.alert("Your registration is being reviewed, and is pending approval.");
            }
        } else {
            _.shouldnt_happen();
            _.Modal.alert("Bidding Unavailable", "Unable to bid at this time.");
        }

    }

    static async do_custom_bid() {

        let current_round_pub = await _.AuctionUI.get_current_round();
        let current_round = await current_round_pub.private();

        let best_bid_by_user = await _.Lib_Auction_Bids.best_bid_by_user(current_round);
        let is_auto_bid = best_bid_by_user && best_bid_by_user.status == App_Models_Bid.STATUS_MAX_BID_ACTIVE;

        if (!await _.AuctionUI_Session.get_registrant()) {
            _.AuctionUI_Bids.create_account_or_login_form();
        } else if (!_.Lib_Auction_Bids.user_registration_approved()) {
            if (!_.ac_state.registration) {
                _.ac_registeration_modal();
            }
            else if (!_.ac_state.registration.approved) {
                _.Modal.alert("Your registration is being reviewed, and is pending approval.");
            }
        } else if (!await _.Lib_Auction_Bids.can_bid(current_round)) {
            _.Modal.alert("You may not bid at this time.");

        } else if (_.AuctionUI.auction_is_sealed_bid()) {
            _.AuctionUI_Sealed_Bid.place_bids_button_handler();
        } else if (is_auto_bid || (await _.Lib_Auction_Bids.user_bid_pending(current_round))) {
            _.AuctionUI_Bids.edit_bid_modal();
        } else if (await _.Lib_Auction_Bids.can_bid(current_round)) {
            _.AuctionUI_Bids.custom_bid_modal();
        } else {
            _.Modal.alert("You may not bid at this time.");
        }
    }

    static async create_account_or_login_form() {
        // Is this used anywhere?  It looks redundant to a function in auctionui-general-ui.js

        let option = await _.Modal.pick("Account Required",
            "You are not signed in, please create an account or sign in to bid:",
            false, [
            {
                title: "Create Account",
                class: "btn-success",
                value: "create",
                default: false
            },
            {
                title: "Sign In",
                class: "btn-success",
                value: "signin",
                default: false
            },
            {
                title: "Cancel",
                class: "btn-secondary",
                value: "cancel",
                default: true
            }
        ]);
        if (option == 'create') {
            _.AuctionUI_Signup.signup_modal();
        } else if (option == 'signin') {
            _.AuctionUI_Login.login_modal();
        }
    }

    // Update the bidding interface to reflect current state of auction
    // Todo: This is way too long and weird, it needs to be broken up into smaller functions.
    static async _update_bidding_ui() {

        // Let tracks load first.
        if (!_.AuctionUI_Tracks.has_loaded) {
            return;
        }

        // Make this an exclusive run function.
        await _.mutex("_update_bidding_ui", async function () {

            // Todo: Need to deal with non online auction type

            // Hide / show login area according to if auction is active
            let auction = _.ac_state.auction;

            let current_bidding_round = await _.AuctionUI.get_current_round();

            // Invalid item hash, or the round could not be loaded (server busy). Leave the UI as it
            // is: the next update re-runs this. Reloading the page here turned server errors into a
            // page-load herd of every viewer.
            if (!current_bidding_round) {
                console.warn("Can not find bidding round, pronbably navigated to an invalid item hash");
                return;
            }

            current_bidding_round = await current_bidding_round.private();

            let current_item = _.AuctionUI.get_current_item();
            let auction_rounds = auction.auction_rounds.fetch();
            let auction_items = auction.auction_items.fetch();

            current_item = await current_item;
            auction_rounds = await auction_rounds;
            auction_items = await auction_items;

            // clean up this logic
            // current round is the current items round, unless choice auction and the current round is not sold
            let current_round =
                _.AuctionUI.auction_is_choice() &&
                    current_item &&
                    current_item.status == App_Models_AuctionItem.STATUS_SOLD ?
                    (await current_item.auction_round.fetch()) : (
                        !_.AuctionUI.auction_is_choice() || current_bidding_round.status != App_Models_AuctionRound.STATUS_SOLD ?
                            current_bidding_round :
                            null);

            if (!current_bidding_round) {
                _.shouldnt_happen();
                $("#landproz-auctioncast-auction-bidding").hide();
                return;
            } else {
                $("#landproz-auctioncast-auction-bidding").show();
            }

            let current_item_id = current_item ? current_item.id : null;
            let current_round_id = current_round ? current_round.id : null;
            let current_bidding_round_id = current_bidding_round.id;
            let viewing_current_round = current_bidding_round_id == current_round_id;

            // Determine if we just changed auction tracks.  if we have, all animations will be 0 rather than fade in effect.

            let just_changed_tracks = current_item_id != _.AuctionUI_Bids._old_item_id ||
                current_round_id != _.AuctionUI_Bids._old_round_id;

            if (just_changed_tracks) {
                _.AuctionUI_Bids._old_item_id = current_item_id;
                _.AuctionUI_Bids._old_round_id = current_round_id;
            }

            // Lookup if auction is in a 'pending' state.  Used for later code.
            let auction_pending = false;
            if (auction.auction_status == App_Models_Auction.STATUS_PUBLISHED || auction.auction_status == App_Models_Auction.STATUS_IN_REVIEW || auction.auction_status == App_Models_Auction.STATUS_DRAFT) {
                auction_pending = true;
            } else {
                let all_auction_rounds_pending = true;
                for (let i in auction_rounds) {
                    if (auction_rounds[i].status != App_Models_AuctionRound.STATUS_PENDING) {
                        all_auction_rounds_pending = false;
                    }
                }
                if (all_auction_rounds_pending) {
                    auction_pending = true;
                }
            }

            // Reset Bidding Details UI
            $(".bidding-sold-area").hide();

            // Reset UI if this is the first time we looked at this track
            if (just_changed_tracks) {
                // Reset if we are looking at a different item or round than we just were.
                // just_changed_tracks = true will also supress fade in animations when switching tracks
                $("[class^='ac-bids-bigauctionstatus']").hide();
                $("[class^='your-bid-is']").hide();
                $(".bidding-prices-area-your-bid").hide();
                $(".bidding-prices-area").removeClass("bidding-prices-area-has-bids");
                $(".bidding-badges-area").removeClass("bidding-prices-area-has-bids");
                $(".bidding-prices-area").append($(".bidding-badges-area"));
                $(".ac-component-bid-winner").empty();
            }

            if (!current_round && auction_items.length == 0) {
                // There are no items error.
                // Test me?  Disable all items and see what shows.
                $(".ac-component-bid-auction-no-items").show();
                $(".ac-bids-bigauctionstatus-group-item").hide();
            } else if (!current_item) {
                // Represent no item
                $(".ac-component-bid-auction-no-item-selected").show();
                $(".ac-component-bid-auction-lots-details").hide();
                $(".ac-bids-bigauctionstatus-group-item").hide();
            } else {
                // Represent item.
                $(".ac-component-bid-auction-no-item-selected").hide();
                $(".ac-component-bid-auction-lots-details").show();
            }


            // CODE ABOVE IS FOR ITEM DETAILS

            // if (_.AuctionUI.auction_is_sealed_bid()) {
            //     return;
            // }

            // CODE BELOW IS FOR PRICES

            // Relisted tract: hide bidding controls, show relisted notice
            if (current_item && current_item.converted_to_auction_url) {
                $(".ac-component-bid-price-container").hide();
                $(".bidding-place-bid-area").hide();
                $(".ac-component-bid-relisted-link").attr('href', current_item.converted_to_auction_url);
                $(".ac-component-bid-relisted-notice").show();
                $(".ac-component-bid").show();
                return;
            } else {
                $(".ac-component-bid-relisted-notice").hide();
            }

            if (!current_round) {
                // Represent no round
                $(".bidding-prices-area").hide();
                $(".ac-bids-bigauctionstatus-group-bidding").hide();
            } else {
                // Represent round
                $(".bidding-prices-area").show();

                if (_.AuctionUI.auction_is_choice()) {
                    let $bidding_box_title = $("#landproz-auctioncast-auction-bidding .ac-greenbox-title");
                    $bidding_box_title.text("BIDDING - ROUND " + current_round.round_number + " - " + current_round.status_label.toUpperCase());
                }
            }

            let show_bid_button =
                current_round &&
                current_round.status != App_Models_AuctionRound.STATUS_SOLD &&
                viewing_current_round;

            $(".ac-btn-quickbid").set_conditional_visibility(show_bid_button);
            $(".ac-component-bid-price").set_conditional_class('ac-component-bid-price-inactive', !show_bid_button)

            // Update high bidder / sold to bidder text above quick bid button
            let $winner_notice = $(".ac-component-bid-winner");

            if (current_round) {
                // ----- SET BASIC PROPERTIES OF ITEM IN BIDDING DISPLAY ----

                // Some random resets... spaghetti...
                if (!_.AuctionUI.auction_is_sealed_bid()) {
                    $(".ac-bid-peracre-total").text('');
                }

                // Get the bidding container
                let $container = $(".ac-component-bid");

                // Update auction status
                let $status = $container.find(".ac-round-bidding-state");

                $status.text(current_round.status_label);

                if (!$status.hasClass(current_round.status_badge)) {
                    $status.attr('class', function (i, c) {
                        return c.replace(/(^|\s)badge-\S+/g, '');
                    });
                    $status.addClass(current_round.status_badge_frontend);
                }

                // ------ HANDLE: ITEM PENDING - show no bidding data -------

                // Load all the data.

                // Load these in parallel:
                let p_user_bid_pending = _.Lib_Auction_Bids.user_bid_pending(current_round);
                let p_best_bid_by_user = _.Lib_Auction_Bids.best_bid_by_user(current_round);
                let p_current_bid = current_round.current_bid ? (current_round.current_bid.fetch()) : null;

                // let p_user_bid_max = _.Lib_Auction_Bids.user_bid_max(current_round);

                // Resolve
                let user_bid_pending = await p_user_bid_pending;  // If a user has a pending bid, get it
                let best_bid_by_user = await p_best_bid_by_user; // The best bid that the user has submitted - could be high, current, or outbid bid
                let current_bid = await p_current_bid; // The active bid for the round:

                let is_auto_bid = best_bid_by_user && best_bid_by_user.status == App_Models_Bid.STATUS_MAX_BID_ACTIVE;
                let is_auto_bid_pending = best_bid_by_user && (best_bid_by_user.status == App_Models_Bid.STATUS_MAX_BID_PENDING || best_bid_by_user.status == App_Models_Bid.STATUS_MAX_BID_PENDING_APPROVAL);

                // Is the current high bid for the logged in user?
                let is_high_bidder = _.ac_state.registrant &&
                    current_bid &&
                    current_bid.registrant.id == _.ac_state.registrant.id &&
                    current_bid.status == App_Models_Bid.STATUS_ACCEPTED;

                let label_your_bid_is_sold =
                    current_round.status == App_Models_AuctionRound.STATUS_SOLD && is_high_bidder;

                let label_your_bid_is_high_bid = show_bid_button &&
                    !label_your_bid_is_sold &&
                    is_high_bidder;

                let label_your_bid_is_pending = show_bid_button &&
                    !label_your_bid_is_sold &&
                    !label_your_bid_is_high_bid &&
                    best_bid_by_user && (
                        best_bid_by_user.status == App_Models_Bid.STATUS_PENDING ||
                        best_bid_by_user.status == App_Models_Bid.STATUS_PENDING_APPROVAL ||
                        best_bid_by_user.status == App_Models_Bid.STATUS_MAX_BID_PENDING ||
                        best_bid_by_user.status == App_Models_Bid.STATUS_MAX_BID_PENDING_APPROVAL
                    );

                let label_your_bid_is_outbid =
                    best_bid_by_user &&
                    !label_your_bid_is_sold &&
                    !is_high_bidder &&
                    !label_your_bid_is_pending &&
                    !_.AuctionUI.auction_is_sealed_bid();

                // Always outbid if you have a bid but enterprise no sale (or the lost side: Sold as Whole Farm / Sold as Tracts)
                if (best_bid_by_user && _.AuctionUI.auction_is_enterprise() && current_round.status_is_unsold) {
                    label_your_bid_is_outbid = true;
                }

                let label_choice_item_is_available_for_bidding =
                    _.AuctionUI.auction_is_choice() &&
                    current_item &&
                    current_item.status == App_Models_AuctionItem.STATUS_AVAILABLE &&
                    current_bidding_round && current_bidding_round.status_can_bid;

                let label_choice_item_is_available =
                    _.AuctionUI.auction_is_choice() &&
                    current_item &&
                    current_item.status == App_Models_AuctionItem.STATUS_AVAILABLE &&
                    !(current_bidding_round && current_bidding_round.status_can_bid);

                let current_price = current_round.current_price;

                if (current_bid) {

                    let total_bids = await _.Lib_Auction_Bids.count_total_bids(current_round);

                    let winning_text = "";

                    if (current_round.status == App_Models_AuctionRound.STATUS_SOLD) {
                        winning_text = '<strong>Lot sold to Bidder: ';
                    } else if (current_round.status_is_unsold) {
                        winning_text = 'High Bidder: <strong>';
                    } else {
                        winning_text = "Total Bids: <strong>" + total_bids + "</strong>&nbsp;&nbsp;&nbsp;&nbsp;";
                        winning_text += 'High Bidder: <strong>';
                    }

                    if (current_bid.paddle_number) {
                        if (_.ac_state.registration && _.ac_state.registration.paddle_number &&
                            current_bid.paddle_number == _.ac_state.registration.paddle_number) {
                            winning_text += "<span style='color:#009f00;'>[" + current_bid.paddle_number + "]</span>";
                        } else {
                            winning_text += "[" + current_bid.paddle_number + "]";

                        }
                    } else {
                        winning_text += "Floor Bid";
                    }

                    if (current_round.status == App_Models_AuctionRound.STATUS_SOLD && _.AuctionUI.auction_is_choice()) {
                        winning_text += " on Round " + current_round.round_number;
                    }

                    winning_text += "</strong>";

                    $winner_notice.empty();
                    $winner_notice.append($("<div>" + winning_text + "</div>"));

                    if (label_your_bid_is_sold) {
                        $winner_notice.append(
                            $("<div style='margin-top: 15px; margin-bottom: -5px;'><span style='color:black; font-weight:bold;'>" +
                                "You Won This " + _.property_noun_item_singular_ucwords() +
                                "</span></div>")
                        );
                    }
                } else {
                    $winner_notice.empty();
                }

                if (current_round.current_bid_amount) {
                    $container.find(".ac-bids-highbid-label").show();
                    $container.find(".ac-bids-startingbid-label").hide();
                } else {
                    $container.find(".ac-bids-highbid-label").hide();
                    $container.find(".ac-bids-startingbid-label").show();
                }

                if (current_round.status == App_Models_AuctionRound.STATUS_SOLD) {
                    $(".bidding-place-bid-area").hide(); // Place bid button
                    $(".bidding-prices-area").style("margin-bottom", "20px"); // No place bid button needs margin tweak
                    $(".bidding-prices-area-high-bid").hide(); // "Sale price" value

                    $(".bidding-prices-area").show();
                    $(".bidding-prices-area-your-bid").hide();
                    best_bid_by_user = false;

                    // $header.hide(); // This is some misengineered logic...
                    $(".bidding-sold-area").show();
                    $(".ac-bids-sale-price").text(_.currency(current_item.sale_price));

                    $(".ac-bids-sale-price-extra-label-1").show().html(
                        await _.AuctionUI.fees_string_v2_multi_line_item(current_item)
                    );
                } else {
                    $(".bidding-sold-area").hide();

                    $(".bidding-place-bid-area").show();
                    $(".bidding-prices-area").style("margin-bottom", "0px");
                    $(".bidding-prices-area-high-bid").show(); // "Sale price" value
                }

                $(".ac-bids-bigauctionstatus-group-item").show();
                $(".ac-bids-bigauctionstatus-group-bidding").show();

                let this_item_is_low_bid = _.AuctionUI.auction_is_enterprise() && !current_round.enterprise_is_top_bid;
                let this_item_is_top_bid = _.AuctionUI.auction_is_enterprise() && current_round.enterprise_is_top_bid;

                let status_badge_map = {
                    ".ac-bids-bigauctionstatus-pending": current_round.status == App_Models_AuctionRound.STATUS_PENDING,
                    ".ac-bids-bigauctionstatus-active": current_round.status == App_Models_AuctionRound.STATUS_ACTIVE,
                    ".ac-bids-bigauctionstatus-paused": current_round.status == App_Models_AuctionRound.STATUS_PAUSED,
                    ".ac-bids-bigauctionstatus-once": current_round.status == App_Models_AuctionRound.STATUS_ONCE,
                    ".ac-bids-bigauctionstatus-twice": current_round.status == App_Models_AuctionRound.STATUS_TWICE,
                    ".ac-bids-bigauctionstatus-finalizing": current_round.status == App_Models_AuctionRound.STATUS_FINALIZING,
                    ".ac-bids-bigauctionstatus-pending": current_round.status == App_Models_AuctionRound.STATUS_PENDING,
                    ".ac-bids-bigauctionstatus-choice-item-is-available": label_choice_item_is_available,
                    ".ac-bids-bigauctionstatus-choice-item-is-available-for-bidding": label_choice_item_is_available_for_bidding,
                    ".ac-bids-bigauctionstatus-sold": current_round.status == App_Models_AuctionRound.STATUS_SOLD &&
                        current_bidding_round.id == current_round.id &&
                        !label_your_bid_is_sold,
                    ".ac-bids-bigauctionstatus-sold-other-round": current_round.status == App_Models_AuctionRound.STATUS_SOLD &&
                        current_bidding_round.id != current_round.id &&
                        !label_your_bid_is_sold,
                    ".your-bid-is-high-bid": label_your_bid_is_high_bid,
                    ".your-bid-is-sold-bid": label_your_bid_is_sold,
                    ".your-bid-is-outbid-bid": label_your_bid_is_outbid,
                    ".your-bid-is-pending-bid": label_your_bid_is_pending,
                    ".this-item-is-low-bid": this_item_is_low_bid,
                    ".this-item-is-top-bid": this_item_is_top_bid,
                    ".status-this-item-is-canceled": current_round.status == App_Models_AuctionRound.STATUS_CANCELED
                };

                // console.log(label_your_bid_is_high_bid);

                // Notice for high bid but low bid enterprise
                $(".ac-enterprise-your-bid-is-high-but-low-wf").hide();
                $(".ac-enterprise-your-bid-is-high-but-low-ind").hide();

                if (label_your_bid_is_high_bid && this_item_is_low_bid) {
                    if (current_round.enterprise_is_whole_farm) {
                        $(".ac-enterprise-your-bid-is-high-but-low-wf").show();
                    } else {
                        $(".ac-enterprise-your-bid-is-high-but-low-ind").show();
                    }
                }

                // Sold related stuff.

                if (current_round.status == App_Models_AuctionRound.STATUS_SOLD) {
                    // Update sold bid labels for choice to reflect sold round
                    // TEST: DOES THIS EVEN WORK?
                    // I don't think it does...
                    if (_.AuctionUI.auction_is_choice()) {
                        if (label_your_bid_is_sold) {
                            $(".your-bid-is-sold-bid .bid-badge-you-won").text("SOLD - ROUND " + current_round.round_number + " - YOU WON");
                        } else {
                            $(".ac-bids-bigauctionstatus-sold .bid-badge-sold").text(
                                "SOLD - ROUND " + current_round.round_number +
                                (current_bid && current_bid.paddle_number ? " - [" + current_bid.paddle_number + "]" : ""));
                        }
                    } else {
                        // ??
                    }
                }

                _.AuctionUI_Bids.__badge_fade_in_fade_out_map(just_changed_tracks ? 0 : 300, status_badge_map);

                if (current_round.status == App_Models_AuctionRound.STATUS_SOLD) { // check not really necessary, but left in to make code easier to follow
                    $(".ac-bids-bigauctionstatus-sold-other-round .bid-badge-sold-other-round").text(
                        _.property_noun_item_singular().toUpperCase() + " SOLD ON ROUND " + current_round.id
                    );
                }

                // Refactor me
                await _.AuctionUI_Bids._render_selected_item_bids_area($container, just_changed_tracks, current_round, current_item, auction,
                    best_bid_by_user, is_auto_bid, is_auto_bid_pending, label_your_bid_is_high_bid, label_your_bid_is_sold, label_your_bid_is_outbid);

                if (_.AuctionUI.auction_is_choice()) {
                    let title_text = "Choice Round " + current_round.round_number;
                    $container.find(".ac-widget-name-current-item").text(title_text);
                    $(".bidding-prices-area-track-name").text(title_text);
                } else if (current_item) {
                    // Update property name, description, and image
                    $container.find(".ac-widget-name-current-item").text(current_item.title);
                    $(".bidding-prices-area-track-name").text(current_item.title);
                }

                // Sale summary button.  Revealed if the user placed any bids during the auction and the auction was sold
                let $sale_summary_button = $("#ac-component-auction-mini-summary-container-more-detail-button").hide();
                $sale_summary_button.hide();

                // Reset can bid button
                $(".ac-bid-button-group .btn").removeClass("btn-success").addClass("btn-secondary");

                if (auction_pending || current_round.status == App_Models_AuctionRound.STATUS_PENDING) {
                    // "Bidding has not yet started for this auction"
                    $(".ac-component-round-pending").show();
                    $(".bidding-place-bid-area").hide();
                    $(".ac-component-auction-mini-summary-container").hide();
                    $(".ac-component-item-detail-spacer").css('display', '');
                } else if ((auction.auction_status == App_Models_Auction.STATUS_CONTRACT || auction.auction_status == App_Models_Auction.STATUS_COMPLETE) &&
                    label_your_bid_is_sold) {
                    $(".ac-component-round-pending").hide();
                    $(".bidding-place-bid-area").hide();
                    $(".ac-component-auction-mini-summary-container").show();
                    await _.AuctionUI_Bids.show_auction_sold_summary();
                    $(".ac-component-item-detail-spacer").css('display', 'block');
                } else {
                    $(".ac-component-round-pending").hide();
                    $(".bidding-place-bid-area").show();
                    $(".ac-component-auction-mini-summary-container").hide();
                    $(".ac-component-item-detail-spacer").css('display', '');

                    // Update quickbid button
                    let user_can_bid = await _.Lib_Auction_Bids.can_bid(current_round); // audit function
                    let user_can_bid_not_pending = user_can_bid && !user_bid_pending;

                    $(".ac-bid-button-group .btn").set_conditional_class("btn-success", user_can_bid_not_pending);
                    $(".ac-bid-button-group .btn").set_conditional_class("btn-secondary", !user_can_bid_not_pending);

                    let min_bid = current_round.ask;

                    if (user_bid_pending) {
                        $container.find(".ac-btn-quickbid").text("Pending: " + _.currency(user_bid_pending.amount));
                    } else if (is_auto_bid && best_bid_by_user) {
                        $container.find(".ac-btn-quickbid").text("Auto Bidding: " + _.currency(best_bid_by_user.amount));
                        // $container.find(".ac-btn-quickbid").text("Auto Bidding to " + _.currency(best_bid_by_user.amount));
                    } else {
                        $container.find(".ac-btn-quickbid").html("<i class='fa-solid fa-gavel'></i> Bid " + _.currency(min_bid));
                    }

                    $container.find(".ac-btn-quickbid").data('amount', min_bid);
                    $container.find(".btn-quickbid-cancel-notice").set_conditional_visibility(user_bid_pending || is_auto_bid);

                    if (user_bid_pending && user_bid_pending.requested_withdraw) {
                        $(".ac-component-bid-requested-withdrawl").show();
                    } else {
                        $(".ac-component-bid-requested-withdrawl").hide();
                    }
                }

                // Final step is to show these elements if not already shown.  It is preferable to keep them hidden while loading initial data.
                if (!_.AuctionUI.auction_is_sealed_bid()) {
                    $container.show();
                    $(".ac-component-bid-price").show();
                    $(".ac-component-bid-price-container").show();
                }
            } else if (current_bidding_round && current_bidding_round.status == App_Models_AuctionRound.STATUS_SOLD) {
                let current_bid = await current_bidding_round.current_bid.fetch();

                let winning_text = "";

                winning_text = '<br /><strong>Round ' + current_bidding_round.round_number + ' has Completed</strong><br /><br />';
                winning_text += 'High Bidder: <strong>';

                if (current_bid.paddle_number) {
                    if (_.ac_state.registration && _.ac_state.registration.paddle_number &&
                        current_bid.paddle_number == _.ac_state.registration.paddle_number) {
                        winning_text += "<span style='color:#009f00;'>[" + current_bid.paddle_number + "]</span>";
                    } else {
                        winning_text += "[" + current_bid.paddle_number + "]";

                    }
                } else {
                    winning_text += "Floor Bid";
                }

                winning_text += "</strong><br />";

                if (current_bid) {
                    winning_text += "High Bid: <strong>" + _.currency(current_bid.amount) + "</strong>";
                }

                // Todo: list tracts sold

                $winner_notice.empty();
                $winner_notice.append($("<div>" + winning_text + "</div>"));
            }

            if (window.fe_elements_rearrange) {
                window.fe_elements_rearrange();
            }

            // Fix formatting for what elements are visible in bidding area
            _.AuctionUI_Bids.add_spacers_to_prices_area();

            // If this is a choice auction, and the current user is the winner of a round, and the round is in sold state,
            // notify the user that the round is complete.
            // ??
            if (_.AuctionUI.auction_is_choice() && // Auction is choice
                current_round && // Round exists
                current_round.status == App_Models_AuctionRound.STATUS_SOLD && // Round sold
                _.ac_state.registrant &&
                _.ac_state.auction.status == App_Models_Auction.STATUS_ACTIVE) // User has not chosen anything
            {
                let high_bid = await current_round.current_bid.fetch();
                if (high_bid && high_bid.registrant_id == _.ac_state.registrant.id) { // We are the winning high bidder

                    let confirmation_message = "You have won the following " + _.property_noun_item_plural_ucwords() + " on round " + current_round.round_number + ":\n\n";

                    let totalItems = 0;
                    let totalAcres = 0;

                    for (let item of (await _.ac_state.auction.auction_items.fetch())) {
                        if (item.auction_round_id == current_round.id) {
                            totalItems++;
                            if (item.acres) {
                                totalAcres += item.acres;
                            }
                            confirmation_message += item.title + "\n";
                        }
                    }

                    let totalCost = totalAcres * high_bid.amount;

                    confirmation_message += "\n";
                    confirmation_message += "Number of " + _.property_noun_item_plural_ucwords() + ": " + totalItems + "\n";
                    confirmation_message += "Total " + _.property_noun_unit_plural_ucwords() + ": " + _.represent_units_with_plusminus(totalAcres) + "\n";
                    confirmation_message += "Total price: " + _.currency(totalCost) + "\n";

                    await _.Modal.alert(confirmation_message);
                }
            }
        });
    }

    // Fix formatting for spacing of elements in pricing area
    static add_spacers_to_prices_area() {

        // The .bidding-prices-area uses a trick where 'spacer' elements are between each visible element to enforce a max gap size.
        // This code creates them.
        var $biddingPricesArea = $(".bidding-prices-area");

        $biddingPricesArea.find(".spacer").remove();

        // Add a spacer at the beginning of the container
        $biddingPricesArea.prepend('<div class="spacer"></div>');

        var $visibleChildren = $biddingPricesArea.children().not('.spacer').filter(':visible');

        let count_children = 0;
        $visibleChildren.each(function () {
            // Add a spacer after each visible element
            $(this).after('<div class="spacer"></div>');
            count_children++;
        });

        // If 3 visible, set css style bidding-prices-area-has-three
        if (count_children >= 3) {
            $biddingPricesArea.addClass('bidding-prices-area-has-three');
        } else {
            $biddingPricesArea.removeClass('bidding-prices-area-has-three');
        }
    }

    // Refactor in progress
    static async _render_selected_item_bids_area($container, just_changed_tracks, current_round, current_item, auction, best_bid_by_user,
        is_auto_bid, is_auto_bid_pending, label_your_bid_is_high_bid, label_your_bid_is_sold, label_your_bid_is_outbid) {

        let current_price = current_round ? current_round.current_price : null;
        let show_total = false;

        // Show fees if any are set

        // if (auction.total_fees > 0) {

        //     // Calculate fees for popup
        //     try {
        //         let feesArray = JSON.parse(auction.fees || '[]'); // Safely parse the JSON

        //         let fees_description = "<strong>Fees:</strong>";

        //         if (feesArray.length > 0) {
        //             fees_description += "\n";

        //             feesArray.forEach(fee => {
        //                 fees_description += `${fee.name}: ${fee.amount}%\n`;
        //             });

        //             fees_description += `Total: ${auction.total_fees}%`;
        //             show_total = true;

        //         } else {
        //             fees_description += " ---";
        //         }

        //         $(".ac-bids-fees-label").data('fees', _.nl2br(fees_description));
        //     } catch (e) {
        //         $(".ac-bids-fees-label").data('fees', null);
        //     }
        // } else {
        // }

        // Middle ask column
        if (current_round.status_can_bid) {
            $(".bidding-prices-area-ask").show();
        } else {
            $(".bidding-prices-area-ask").hide();
        }

        if (await _.Lib_Auction_Bids.can_bid(current_round)) {
            $(".ac-btn-custombid").show();
        } else {
            $(".ac-btn-custombid").hide();
        }

        let $ask_container = $container.find(".ac-bids-ask");
        $ask_container.text(_.currency(current_round.ask));

        // Show "Flat Price" or "Per Acre" below every price
        let acres_mult = 1;
        if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT) {
            $(".ac-bids-peracre-label").text("Flat Price Bidding");
            show_total = true;
        } else if (current_item && !current_item.acres) {
            _.shouldnt_happen();
            $(".ac-bids-peracre-label").text("Per " + _.property_noun_unit_singular_ucwords());
        } else if (current_item) {
            $(".ac-bids-peracre-label").text("Per " + _.property_noun_unit_singular_ucwords() + " (" + _.represent_units_with_plusminus(current_item.acres) + ")");
            show_total = true;
        } else {
            $(".ac-bids-peracre-label").text("");
        }

        if (show_total) {
            if (_.AuctionUI.auction_is_choice() && (!current_item || current_item.status != App_Models_AuctionItem.STATUS_SOLD)) {
                // maybe also check to see if current round complete?
                $(".ac-bids-ask-peracre-total").show().html("+ " + _.percentage(auction.total_fees) + " fees");
            }
            else if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                $(".ac-bids-ask-peracre-total").show().html(
                    await _.AuctionUI.fees_string_v2_multi_line_acres(current_round.ask, current_item.acres)
                );
            } else if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT) {
                $(".ac-bids-ask-peracre-total").show().html(
                    await _.AuctionUI.fees_string_v2_multi_line_flat(current_round.ask)
                );
            } else {
                // Don't know how one gets here.
                $(".ac-bids-ask-peracre-total").show().html("+ " + _.percentage(auction.total_fees) + " fees");
            }
        } else {
            $(".ac-bids-ask-peracre-total").hide();
        }

        // let calculate_total_number = function (input_number) {
        //     console.log(auction.total_fees);
        //     if (current_item) {
        //         if (current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT && !auction.total_fees) {
        //             return input_number;
        //         } else if (current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT && auction.total_fees) {
        //             return input_number + (input_number * (auction.total_fees / 100));
        //         } else if (current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE && !current_item.acres) {
        //             return null;
        //         } else if (current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE && current_item.acres) {
        //             if (auction.total_fees) {
        //                 return (input_number * current_item.acres) + (input_number * current_item.acres * (auction.total_fees / 100));
        //             } else {
        //                 return (input_number * current_item.acres) + (input_number * current_item.acres);
        //             }
        //         }
        //     }

        //     return null;
        // }

        let calculate_total_number = function (input_number) {
            if (current_item) {
                if (current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT) {
                    return input_number;
                } else if (current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE && current_item.acres) {
                    return (input_number * current_item.acres);
                }
            }

            return null;
        }


        // ----- HIGH BID -----

        let current_bid = await current_round.current_bid.fetch();

        let is_high_bidder = _.ac_state.registrant &&
            current_bid &&
            current_bid.registrant.id == _.ac_state.registrant.id &&
            current_bid.status == App_Models_Bid.STATUS_ACCEPTED;

        let $high_bid = $container.find(".ac-bids-highbid");
        let $high_bid_total = $container.find(".ac-bids-highbid-peracre-total");
        let high_bid_old = $high_bid.data('amount');
        let high_bid_changed = high_bid_old && high_bid_old < current_price;

        // Update high bid
        $high_bid.empty();
        $high_bid.text(_.currency(current_price));
        $high_bid.data('amount', current_price);

        // let high_bid_total = calculate_total_number(current_price);
        // if (show_total && !high_bid_changed)

        if (show_total) {
            if (_.AuctionUI.auction_is_choice() && (!current_item || current_item.status != App_Models_AuctionItem.STATUS_SOLD)) {
                // maybe also check to see if current round complete?
                $high_bid_total.show().html("+ " + _.percentage(auction.total_fees) + " fees");
            }
            else if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                $high_bid_total.show().html(
                    await _.AuctionUI.fees_string_v2_multi_line_acres(current_price, current_item.acres)
                );
            } else if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT) {
                $high_bid_total.show().html(
                    await _.AuctionUI.fees_string_v2_multi_line_flat(current_price)
                );
            } else {
                // Don't know how one gets here.
                $high_bid_total.show().html("+ " + _.percentage(auction.total_fees) + " fees");
                // $(".ac-bids-yourbid-peracre-total").hide();
            }
        } else {
            $high_bid_total.hide();
        }

        // Turn high bid green if it is our high bid
        $high_bid.set_conditional_class('bid-text-highbid', is_high_bidder || label_your_bid_is_sold);

        // Make high bid pop if changed
        if (high_bid_changed && !just_changed_tracks) {
            $high_bid.popValue();
        }

        // ------ USER BID RELATED STUFF - ONLY SHOWS IF LOGGED IN AND BIDDING ACTIVE -----

        // Todo: The user has placed no bids

        let $user_bid_container = $container.find(".ac-bids-yourbid");

        if (best_bid_by_user) {
            // Does the user have any bids?  If so, render it, also move badges below the prices

            $(".bidding-prices-area-your-bid").show();
            $(".bidding-prices-area").addClass("bidding-prices-area-has-bids");
            $(".bidding-badges-area").addClass("bidding-prices-area-has-bids");
            $(".bidding-badges-area").insertAfter($(".bidding-prices-area"));

            $user_bid_container.empty();
            $user_bid_container.text(_.currency(best_bid_by_user.amount));
            $user_bid_container.data('amount', best_bid_by_user.amount);

            $(".bidding-prices-area-your-bid-text").text(best_bid_by_user.status == App_Models_Bid.STATUS_MAX_BID_ACTIVE ? "Your Max Bid:" : "Your Bid:");

            $user_bid_container.set_conditional_class('bid-text-highbid', label_your_bid_is_high_bid);
            $user_bid_container.set_conditional_class('bid-text-sold', label_your_bid_is_sold);
            $user_bid_container.set_conditional_class('bid-text-outbid', label_your_bid_is_outbid);

            _.AuctionUI_Bids.__badge_fade_in_fade_out_map(just_changed_tracks ? 0 : 300, {

            });

            // Hide generic sold bid if sold- your bid is showing
            if (label_your_bid_is_sold) {
                $(".ac-bids-bigauctionstatus-sold").hide();
            }

            if (!is_auto_bid && !is_auto_bid_pending) {
                if (_.ac_state.auction.enable_auto_bid) {
                    $(".ac-btn-custombid").text("Custom & Max Bid");
                } else {
                    $(".ac-btn-custombid").text("Custom Bid");
                }
            } else {
                $(".ac-btn-custombid").text("Edit Max Bid");
            }

            // Calculate per acre representation
            // if (current_item) {
            //     $(".ac-bids-yourbid-peracre").show();
            // } else {
            //     $(".ac-bids-yourbid-peracre").hide();
            // }


            if (show_total) {
                if (_.AuctionUI.auction_is_choice() && (!current_item || current_item.status != App_Models_AuctionItem.STATUS_SOLD)) {
                    // maybe also check to see if current round complete?
                    $(".ac-bids-yourbid-peracre-total").show().html("+ " + _.percentage(auction.total_fees) + " fees");
                }
                else if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                    $(".ac-bids-yourbid-peracre-total").show().html(
                        await _.AuctionUI.fees_string_v2_multi_line_acres(best_bid_by_user.amount, current_item.acres)
                    );
                } else if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT) {
                    $(".ac-bids-yourbid-peracre-total").show().html(
                        await _.AuctionUI.fees_string_v2_multi_line_flat(best_bid_by_user.amount)
                    );
                } else {
                    // Don't know how one gets here.
                    $(".ac-bids-yourbid-peracre-total").show().html("+ " + _.percentage(auction.total_fees) + " fees");
                    // $(".ac-bids-yourbid-peracre-total").hide();
                }
            }
        }
    }


    // For each group, only one badge may show. If the badge changes, it should fade out old one and fade in new one.
    static async __badge_fade_in_fade_out_map(speed, map) {

        // Fade looks bad when switching tracts.  Lets made speed 0 for now.
        speed = 0;

        let fadeOutPromises = [];
        for (let selector in map) {
            if (!map[selector]) {
                let $element = $(selector);
                // if the element is already visible, just call the callback
                if ($element.is(':visible')) {
                    fadeOutPromises.push($element.aFadeOut(speed));
                }
            }
        }

        await Promise.all(fadeOutPromises);

        let fadeInPromises = [];
        for (let selector in map) {
            if (map[selector]) {
                let $element = $(selector);
                // if the element is already visible, just call the callback
                if ($element.not(':visible')) {
                    fadeOutPromises.push($element.aFadeIn(speed));
                }
            }
        }

        await Promise.all(fadeInPromises);
    }


    static async custom_bid_modal(item_id = null) {

        let $modal = $("#ac-modal-custom-bid-modal");

        if (! await _.AuctionUI_Auction_Registration.validate_toc_is_current(true)) {
            return;
        }

        if (item_id && (await _.AuctionUI.get_current_item()).id != item_id) {
            await _.AuctionUI.set_current_item(item_id);
        }

        let current_round = await (await _.AuctionUI.get_current_round()).private();
        let current_item = await _.AuctionUI.get_current_item();
        let current_max_bid = await _.Lib_Auction_Bids.user_bid_max(current_round);
        let min_acceptable_value = current_max_bid ? current_max_bid.amount + current_round.increment : current_round.ask;

        // Add 'per acre' if appropriate
        if (_.AuctionUI.auction_is_choice() || (
            _.AuctionUI.auction_is_standard_or_enterprise() &&
            current_item &&
            current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE
        )) {
            $(".custom-bid-per-acre-label").show();
        } else {
            $(".custom-bid-per-acre-label").hide();
        }

        // Hide / show auto bid based on auction preference
        if (!_.ac_state.auction.enable_auto_bid) {
            $("#ac-modal-custom-bid-modal").addClass('no-max-bid');
        } else {
            $("#ac-modal-custom-bid-modal").removeClass('no-max-bid');
        }

        // Hide / show custom bids will be approved message based on if enabled for auction
        if (_.ac_state.auction.auto_approve != App_Models_Auction.AUTO_APPROVE_ALL) {
            $("#ac-modal-custom-bid-modal .form-hint-approval").show();
        } else {
            $("#ac-modal-custom-bid-modal .form-hint-approval").hide();
        }

        let update_acres_hint = async function ($input, $target) {
            let inputvalue = $input.val();

            if (!inputvalue) {
                inputvalue = 0;
            }

            let fees_string_fees = "";

            if (current_item.acres && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                fees_string_fees += "<div style='margin-bottom: 15px;'>" +
                    "Per " + _.property_noun_unit_singular() + " for this " +
                    _.represent_units_with_plusminus(current_item.acres) + " " +
                    _.property_noun_unit_singular() + " " +
                    _.property_noun_item_singular() + ":</div>";
                fees_string_fees += "<div class='fees-hint-custom-calc'>" +
                    await _.AuctionUI.fees_string_v2_multi_line_acres(inputvalue, current_item.acres) +
                    "</div>";
            } else {
                fees_string_fees += "<div style='margin-bottom: 15px;'>Flat price bidding</div>";
                fees_string_fees += "<div class='fees-hint-custom-calc'>" +
                    await _.AuctionUI.fees_string_v2_multi_line_flat(inputvalue) +
                    "</div>";
            }

            if (fees_string_fees != '') {
                $target.show().html(fees_string_fees);
            } else {
                $target.hide();
            }
        };


        // Function to regenerate pricing hints on both fields
        let update_both_acres_hint = function () {
            update_acres_hint($input_std, $hint_std);
            update_acres_hint($input_max, $hint_max);
        }

        $(".wf_low_bid_cure_custom_bid_notice").html(await _.AuctionUI_Bids.generate_wf_bid_notice());

        // todo
        // if (_.AuctionUI.auction_is_enterprise()) {
        //     let auction = _.ac_state.auction;
        //     let round = await current_item.auction_round.fetch();
        //     if (auction.enterprise_has_any_bids) {
        //         if (!round.enterprise_is_whole_farm && auction.enterprise_whole_farm_is_top_bid) {
        //             let required_bid_text = "<strong>" + _.currency(round.enterprise_required_bid_to_be_top_bid) + "</strong>";
        //             // let item = await round.auction_item.fetch();

        //             // if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
        //             //     required_bid_text += " (" + _.currency(round.enterprise_required_bid_to_be_top_bid * item.acres) + ")";
        //             // }

        //             fields['_enterpriseHint'] = $('<div class="ac-enterprise-low-bid-notice-bid" style="font-size: 13px; margin:0; width:300px; padding:5px;">' +
        //                 'The Whole Farm is Top Bid. If you place a bid for ' + required_bid_text + ', it will be enough to switch the Top Bid to Individual Items.' +
        //                 '</div>');
        //         }

        //         if (round.enterprise_is_whole_farm && !auction.enterprise_whole_farm_is_top_bid) {
        //             let required_bid_text = "<strong>" + _.currency(round.ask) + "</strong>";
        //             // let item = await round.auction_item.fetch();

        //             // if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
        //             //     required_bid_text += " (" + _.currency(round.ask * item.acres) + ")";
        //             // }

        //             fields['_enterpriseHint'] = $('<div class="ac-enterprise-low-bid-notice-bid" style="font-size: 13px; margin:0; width:300px; padding:5px;">' +
        //                 'Individual Items are Top Bid. If you place a bid for ' + required_bid_text + ', it will be enough to switch the Top Bid to Whole Farm.' +
        //                 '</div>');
        //         }
        //     }
        // }

        // Done with UI stuff, now event handlers.

        $modal.modal_show();

        setTimeout(function () {
            $("#custom-bid-val-std").focus();
        }, 200);

        _.set_poised_modal(true);

        let submit_std = async function () {
            console.log("Check for dup handlers");

            _.reset_form_errors($modal);

            let amount = parseInt($("#custom-bid-val-std").val());

            try {
                $(".btn-submit-custom-std").addClass('ac-async-pleasewait');
                await _.AuctionUI_Bids.place_bid(amount, false, false, current_round.id);
                $(".btn-submit-custom-std").removeClass('ac-async-pleasewait');
                _.set_poised_modal(false);
                _.Modal.hide();
            } catch (error) {
                $(".btn-submit-custom-std").removeClass('ac-async-pleasewait');
                _.apply_form_errors($modal.find('.card-body-std'), { "custom-bid-val-std": error });
                _.set_poised_modal(true);
            }
        }

        let submit_max = async function () {
            _.reset_form_errors($modal);

            let amount = parseInt($("#custom-bid-val-max").val());

            try {
                $(".btn-submit-custom-max").addClass('ac-async-pleasewait');
                await _.AuctionUI_Bids.place_bid(amount, false, true, current_round.id);
                $(".btn-submit-custom-max").removeClass('ac-async-pleasewait');
                _.set_poised_modal(false);
                _.Modal.hide();
            } catch (error) {
                $(".btn-submit-custom-max").removeClass('ac-async-pleasewait');
                _.apply_form_errors($modal.find('.card-body-max'), { "custom-bid-val-max": error });
                _.set_poised_modal(true);
            }
        }

        // Define input fields
        let $input_std = $("#custom-bid-val-std");
        let $input_max = $("#custom-bid-val-max");
        let $hint_std = $(".fees-hint-custom-std");
        let $hint_max = $(".fees-hint-custom-max");

        // Reset form statevalues
        $input_std.val(current_round.ask);
        $input_max.val(current_round.ask);
        _.reset_form_errors($modal);
        update_both_acres_hint();

        // Remove and reattach event handlers
        $input_std.off('change').on('change', update_both_acres_hint);
        $input_max.off('change').on('change', update_both_acres_hint);
        $input_std.off('keyup').on('keyup', function (e) {
            update_both_acres_hint();
            if (e.keyCode === 13) {
                submit_std(); // Enter to submit
            }
        });
        $input_max.off('keyup').on('keyup', function (e) {
            update_both_acres_hint();
            if (e.keyCode === 13) {
                submit_max();  // Enter to submit
            }
        });

        // Submit buttons
        $(".btn-submit-custom-std").off('click').on('click', submit_std);
        $(".btn-submit-custom-max").off('click').on('click', submit_max);
    }


    static async try_bid(item_id, amount) {
        if (! await _.AuctionUI_Auction_Registration.validate_toc_is_current(true)) {
            return;
        }

        if (item_id && (await _.AuctionUI.get_current_item()).id != item_id) {
            await _.AuctionUI.set_current_item(item_id);
        }

        // The round this amount is for: the bid is refused if the current round changes before it is confirmed
        let bid_round = await _.AuctionUI.get_current_round();

        // Handle situations: low bid, auction closed 
        _.set_poised_modal(true);

        let confirm;

        if (_.AuctionUI.auction_is_standard_or_enterprise()) {

            let current_item = await _.AuctionUI.get_current_item();

            let confirm_bid_markup = "" +
                "<span>Please confirm your bid for:<br /><br />" +
                "<strong style='font-size:22px;'>" + _.htmlescape(current_item.title) + "</strong><br /><br />" +
                "<strong style='font-size:30px;'>" + _.currency(amount) + "</strong><br /><br />";

            if (_.AuctionUI.auction_is_choice()) {
                confirm_bid_markup += "+ " + _.percentage(auction.total_fees) + " fees";
            } else if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                confirm_bid_markup += await _.AuctionUI.fees_string_v2_multi_line_acres(amount, current_item.acres);
            } else if (current_item && current_item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_FLAT) {
                confirm_bid_markup += await _.AuctionUI.fees_string_v2_multi_line_flat(amount)
            } else {
                _.shouldnt_happen();
                confirm_bid_markup += "+ " + _.percentage(auction.total_fees) + " fees"
            }

            // bid up dialog here
            confirm_bid_markup += await _.AuctionUI_Bids.generate_wf_bid_notice();

            confirm = await _.Modal.pick("Confirm Bid", $(confirm_bid_markup),
                null,
                [{
                    title: "Cancel",
                    class: "btn-danger",
                    value: "cancel",
                    default: true
                }, {
                    title: "Custom Amount",
                    class: "btn-secondary",
                    value: "custom",
                    default: false
                },
                {
                    title: "Confirm Bid",
                    class: "btn-success",
                    value: "confirm",
                    default: false
                }]

            );

        } else {

            let auction = _.ac_state.auction;
            let property = await auction.property.fetch();

            confirm = await _.Modal.pick("Confirm Bid", $("" +
                "<span>Please confirm your bid for:<br /><br />" +
                "<strong style='font-size:28px;'>" + _.currency(amount) + "</strong>"),
                null,
                [{
                    title: "Cancel",
                    class: "btn-secondary",
                    value: "cancel",
                    default: true
                }, {
                    title: "Custom Amount",
                    class: "btn-secondary",
                    value: "custom",
                    default: false
                },
                {
                    title: "Confirm",
                    class: "btn-success btn-confirm-for-poised",
                    value: "confirm",
                    default: false
                }]
            );
        }

        _.set_poised_modal(false);

        if (confirm == 'confirm') {
            _.AuctionUI_Bids.place_bid(amount, true, false, bid_round ? bid_round.id : null);
        }

        if (confirm == 'custom') {
            _.AuctionUI_Bids.custom_bid_modal();
        }
    }

    // If this is an enterprise auction, returns html hint of how to cure low bid if applicable to current round
    static async generate_wf_bid_notice() {

        let current_item = await _.AuctionUI.get_current_item();

        let confirm_bid_markup = '';

        let show_notice_individual_items_low_bid = false;
        let show_notice_individual_items_low_bid_amt = 0;

        let show_notice_individual_wf_low_bid = false;
        let show_notice_individual_wf_low_bid_amt = 0;

        if (_.AuctionUI.auction_is_enterprise()) {
            let auction = _.ac_state.auction;
            let round = await current_item.auction_round.fetch();

            if (auction.enterprise_has_any_bids) {
                if (!round.enterprise_is_whole_farm && auction.enterprise_whole_farm_is_top_bid) {
                    show_notice_individual_items_low_bid = true;
                    show_notice_individual_items_low_bid_amt = round.enterprise_required_bid_to_be_top_bid;
                }

                if (round.enterprise_is_whole_farm && !auction.enterprise_whole_farm_is_top_bid) {
                    show_notice_individual_wf_low_bid = true;
                    show_notice_individual_wf_low_bid_amt = round.ask;
                }
            }
        }

        // The whole farm lot's name, HTML-escaped for the markup below
        let wf_title = $('<div>').text(await _.AuctionUI_Data.whole_farm_title()).html();

        if (show_notice_individual_items_low_bid) {
            // let round = await current_item.auction_round.fetch();
            // let item = current_item;
            let required_bid_text = "<strong>" + _.currency(show_notice_individual_items_low_bid_amt) + "</strong>";

            // if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
            //     required_bid_text += " (" + _.currency(show_notice_individual_items_low_bid_amt * item.acres) + ")";
            // }

            confirm_bid_markup += '<div class="ac-enterprise-low-bid-notice-bid" style="font-size: 13px; margin-top:10px; width:300px; padding:5px;">' +
                wf_title + ' is Top Bid. If you place a bid for ' + required_bid_text + ', it will be enough to switch the Top Bid to Individual Items.' +
                '</div>';

        } else if (show_notice_individual_wf_low_bid) {

            // let round = await current_item.auction_round.fetch();
            // let item = current_item;
            let required_bid_text = "<strong>" + _.currency(show_notice_individual_wf_low_bid_amt) + "</strong>";

            // if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
            //     required_bid_text += " (" + _.currency(show_notice_individual_wf_low_bid_amt * item.acres) + ")";
            // }

            confirm_bid_markup += '<div class="ac-enterprise-low-bid-notice-bid" style="font-size: 13px; margin-top:10px; width:300px; padding:5px;">' +
                'Individual Items are Top Bid. If you place a bid for ' + required_bid_text + ', it will be enough to switch the Top Bid to ' + wf_title + '.' +
                '</div>';
        }

        return confirm_bid_markup;
    }

    static async edit_bid_modal() {
        if (! await _.AuctionUI_Auction_Registration.validate_toc_is_current(true)) {
            return;
        }

        let current_round = await (_.AuctionUI.get_current_round());

        // Handle situations: low bid, auction closed 
        let pending_bid = await _.Lib_Auction_Bids.user_bid_pending(current_round);
        let max_bid = await _.Lib_Auction_Bids.user_bid_max(current_round);

        if (!pending_bid) {
            pending_bid = max_bid;
        }

        if (!pending_bid) {
            _.shouldnt_happen();
            return;
        }

        let item = await current_round.auction_item.fetch();

        let is_active_max_bid = false;
        let is_pending_max_bid = false;

        if (pending_bid.status == App_Models_Bid.STATUS_MAX_BID_ACTIVE) {
            is_active_max_bid = true;
        }

        if (pending_bid.status == App_Models_Bid.STATUS_MAX_BID_PENDING || pending_bid.status == App_Models_Bid.STATUS_MAX_BID_PENDING_APPROVAL) {
            is_pending_max_bid = true;
        }

        let theMessage = "<span>You have " + (is_active_max_bid ? "an active " : "a pending ") + (is_pending_max_bid || is_active_max_bid ? "max " : "") + "bid for:<br /><br />" +
            "<strong>" + _.currency(pending_bid.amount) + "</strong>";

        if (_.AuctionUI.auction_is_standard_or_enterprise() && item) {
            theMessage += "<br /><br />On " + _.property_noun_item_singular() + ":<br /><br />" +
                "<strong>" + _.htmlescape(item.title) + "</strong>";
        }

        let option = await _.Modal.pick("Modify Bid", $(theMessage),
            false, [{
                title: "Cancel",
                class: "btn-secondary",
                value: "cancel",
                default: true
            }, {
                title: is_active_max_bid ? "Stop Max Bid" : "Withdraw Bid",
                class: "btn-danger",
                value: "withdraw",
                default: false
            }, {
                title: "Raise Bid",
                class: "btn-success",
                value: "raise",
                default: false
            },
        ]);

        if (option == 'raise') {
            _.AuctionUI_Bids.custom_bid_modal();
        } else if (option == 'withdraw') {
            this.try_withdraw_bid();
        }

    }

    static async try_withdraw_bid() {
        let current_round = await (_.AuctionUI.get_current_round());
        let pending_bid = await _.Lib_Auction_Bids.user_bid_pending(current_round);
        let max_bid = await _.Lib_Auction_Bids.user_bid_max(current_round);

        if (!pending_bid) {
            pending_bid = max_bid;
        }

        // Immediatly submit requests to cancel max bid.  This behavior may change later.
        if (pending_bid.status == App_Models_Bid.STATUS_MAX_BID_ACTIVE || pending_bid.status == App_Models_Bid.STATUS_MAX_BID_PENDING ||
            pending_bid.status == App_Models_Bid.STATUS_MAX_BID_PENDING_APPROAL) {
            _.AuctionUI_Bids.withdraw_bid(pending_bid);
            return;
        }

        let item = await current_round.auction_item.fetch();

        if (!pending_bid) {
            _.flash_alert("No active bid to withdraw");
            return;
        }

        // Handle situations: low bid, auction closed 

        let theMessage = "<span>Withdrawl is not guaranteed.<br /><br />" +
            "<span>Please confirm request to withdraw bid:<br /><br />" +
            "<strong>" + _.currency(pending_bid.amount) + "</strong>";

        if (_.AuctionUI.auction_is_standard_or_enterprise() && item) {
            theMessage += "<br /><br />" +
                "On " + _.property_noun_item_singular() + ":<br /><br />" +
                "<strong>" + _.htmlescape(item.title) + "</strong>";
        }

        let confirm = await _.Modal.pick("Confirm Withdraw Bid", $(theMessage
        ), false, [{
            title: "Cancel",
            class: "btn-secondary",
            value: false,
            default: true
        },
        {
            title: "Confirm",
            class: "btn-danger",
            value: true,
            default: false
        }]);

        if (confirm) {
            _.AuctionUI_Bids.withdraw_bid(pending_bid);
        }
    }


    /**
     * Places a bid of amount on the current round. expected_round_id: the round the amount was chosen for (the
     * confirm / custom bid box remembers it); when the current round is another one by now (a choice round
     * ended meanwhile) the bid is refused, never placed on the new round. With
     * is_main_place_bid_button_handle_error false the caller shows errors (the error is thrown).
     */
    static async place_bid(amount, is_main_place_bid_button_handle_error = true, auto_bid_pref = false, expected_round_id = null) {
        let current_round = await (_.AuctionUI.get_current_round());

        if (expected_round_id && (!current_round || current_round.id != expected_round_id)) {
            let message = "The round changed while you were bidding. Please review the new ask and bid again.";
            if (!is_main_place_bid_button_handle_error) {
                throw message;
            }
            _.Modal.hide();
            await _.Modal.alert("Round Changed", message);
            return;
        }

        console.warn("Placing bid for " + amount);

        if (is_main_place_bid_button_handle_error) {
            $(".ac-btn-quickbid").addClass('ac-async-pleasewait');
        }

        let data = {
            auction_round_id: current_round.id,
            amount: amount,
            auto_bid_pref: auto_bid_pref ? 1 : 0
        };

        let bid_id;

        try {

            // bid_id = await _.backend_ajax('auctions', 'bid', data);

            bid_id = await _.ajax({
                url: '/api/ext_v1/auctions/bid',
                method: 'POST',
                data: data,
                dataType: "json",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', 'Bearer ' + _.AuctionUI_Session.get_token_cookie());
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.error(jqXHR);
                }
            });

        } catch (error) {
            // The custom bid box shows the error on its form
            if (!is_main_place_bid_button_handle_error) {
                $(".ac-btn-quickbid").removeClass('ac-async-pleasewait');
                throw _.extract_error(error);
            }
            // Handle situations:  Outbid, low bid, auction closed, bidding generally not allowed
            // If we got here, we're not sure why the bid was prevented.  Just show a error modal.
            _.Modal.hide();
            console.log(error);
            await _.Modal.alert_error(error, "An error has occured placing your bid:");
            $(".ac-btn-quickbid").removeClass('ac-async-pleasewait');
            return;
        }


        let bid = await App_Models_Bid.get_private(bid_id);

        if (!bid) {
            _.flash_alert("Your bid was placed, but an error occured getting the result.  Please refresh the page.", "danger");
        }

        // wait for a notification check to finish.
        $(".ac-btn-quickbid").removeClass('ac-async-pleasewait');

        _.Lib_Notifications.registrant_notification_handler();
    }

    static async withdraw_bid(pending_bid) {
        console.warn("Withdrawing bid for " + pending_bid.amount);

        try {
            let data = {
                bid_id: pending_bid.id
            };

            await _.backend_ajax('auctions', 'withdraw', data);

            _.flash_alert("Request to withdraw your bid has been sent.", "success");

        } catch (error) {
            // Handle situations:  Outbid, low bid, auction closed, bidding generally not allowed

            await _.Modal.alert_error(error, "An error has occured withdrawing your bid:")
        }
    }

    // Call to update the GUI showing if the bidding is accepted (button turns green or brown)
    // static _ui_could_bid = false;
    static async update_ui_can_bid() {

    }

    static async show_auction_sold_summary() {
        // make sure no race conditions, only execute once.
        if (!_.___show_auction_sold_summary) {
            _.___show_auction_sold_summary = _.exclusive(async function () {

                let $header = $("#ac-component-auction-mini-summary-container-header").hide().empty();
                let $subheader = $("#ac-component-auction-mini-summary-container-subheader").hide().empty();
                let $detail = $("#ac-component-auction-mini-summary-container-detail").hide().empty();
                let $sale_summary_button = $("#ac-component-auction-mini-summary-container-more-detail-button").hide();

                // RE ENABLE ME
                // try {

                // Show bidding prices at first.
                $(".bidding-prices-area").show();

                let auction = _.ac_state.auction;
                let round = await _.AuctionUI.get_current_round();
                let item = await _.AuctionUI.get_current_item();
                let current_bid = await round.current_bid.fetch();

                let title_line = [];
                let subtitle_line = [];
                let detail_line = [];

                // Did the user bid at all in this round?  If so, they can see the sale summary button.
                let best_bid_by_user = await _.Lib_Auction_Bids.best_bid_by_user(round);
                if (best_bid_by_user) {
                    $sale_summary_button.show();
                    if (current_bid && best_bid_by_user.id == current_bid.id) {
                        $sale_summary_button.text("Auction & Sale Summary");
                    } else {
                        $sale_summary_button.text("Auction Summary");
                    }
                }

                // Continuing on...
                if (_.AuctionUI.auction_is_enterprise()) {
                    // title_line.push("Auction has Completed");

                    let wf_title = await _.AuctionUI_Data.whole_farm_title();

                    if (auction.enterprise_whole_farm_is_top_bid) {
                        title_line.push("This Auction was sold to " + wf_title);

                        // Redundant for now.  Perhaps reenable when doing refactor.

                        // // Whole Farm Won

                        // let whole_farm_high_bid = await whole_farm_round.current_bid.fetch();

                        // let winning_text = "Whole Farm Sold";

                        // let winning_paddle = "";

                        // if (whole_farm_high_bid.paddle_number) {
                        //     winning_paddle = " to [" + whole_farm_high_bid.paddle_number + "]";
                        // } else {
                        //     winning_paddle = " to Floor Bid";
                        // }

                        // title_line.push(winning_text + winning_paddle);

                        if (round.status_is_unsold) {
                            title_line.push(_.property_noun_item_singular_ucwords() + ": " + round.status_label);

                            subtitle_line.push("Individual " + _.property_noun_item_singular_ucwords() + " Bidding Details:");

                        } else {
                            title_line.push(wf_title + ": SOLD");

                            // detail_line.push("Details for Whole Farm bidding:");
                            // detail_line.push("");
                        }

                    } else {
                        // Individuals Won
                        title_line.push("This Auction was sold to Individual " + _.property_noun_item_plural_ucwords());

                        if (round.enterprise_is_whole_farm) {

                            title_line.push(wf_title + ": " + round.status_label);

                            detail_line.push(wf_title + " Bidding Details:");
                            detail_line.push("");

                        } else {

                            if (round.status == App_Models_AuctionRound.STATUS_NO_SALE) {

                                title_line.push(_.property_noun_item_singular_ucwords() + ": " + round.status_label + " - No Bidders");
                                $(".bidding-prices-area").hide();

                            } else {

                                title_line.push(_.property_noun_item_singular_ucwords() + ": SOLD");

                            }
                        }
                    }
                }

                if (round.round_completed_at) {
                    if (!_.AuctionUI.auction_is_sealed_bid()) {
                        detail_line.push("Total Bids: " + (await _.Lib_Auction_Bids.count_total_bids(round)));
                    }
                    detail_line.push("Bidding closed at " + new _.TimeManager().new(round.round_completed_at_localized).human());
                }

                if (title_line.length) {
                    $header.show();
                    for (let t of title_line) {
                        $header.append($("<div></div>").text(t));
                    }
                }

                if (subtitle_line.length) {
                    $subheader.show();
                    for (let t of subtitle_line) {
                        $subheader.append($("<div></div>").text(t));
                    }
                }

                if (detail_line.length) {
                    $detail.show();
                    for (let t of detail_line) {
                        $detail.append($("<div></div>").text(t));
                    }
                }

                // New sold logic goes here.
                if (round.status == App_Models_AuctionRound.STATUS_SOLD) {  // Not necessary?
                    // $header.hide(); // This is some misengineered logic...
                    $(".bidding-sold-area").show();
                    $(".ac-bids-sale-price").text(_.currency(item.sale_price));
                    if (item.pricing_style == App_Models_AuctionItem.PRICING_STYLE_PER_ACRE) {
                        $(".ac-bids-sale-price-extra-label-1").show().text(
                            _.represent_units_with_plusminus(item.acres) +
                            " at " + _.currency(round.current_price) + " per " + _.property_noun_unit_singular()
                        );
                    } else {
                        $(".ac-bids-sale-price-extra-label-1").hide();
                    }
                    if (auction.total_fees) {
                        $(".ac-bids-sale-price-extra-label-2").show().text("+ " + _.percentage(auction.total_fees) + " buyers premium");
                    } else {
                        $(".ac-bids-sale-price-extra-label-2").hide();
                    }
                } else {
                    // Could be no sale.  Whatever the situation is, deal with it here.
                    // $header.show();
                    $(".bidding-sold-area").hide();
                }

                // Fix formatting for what elements are visible in bidding area
                _.AuctionUI_Bids.add_spacers_to_prices_area();

            });

        }

        await _.___show_auction_sold_summary();
    }

}

jQuery(document).ready(function ($) {
    if ($(".auctioncast-bidding").length) {
        _.AuctionUI_Bid_Element.init($);
    }
});
